export const comments_4088332 = {"data":{"data":[],"links":{}}}